import AuthStore from 'bz-stores/lib/auth-store';
import { FidoStore } from 'core/auth/login/Store/fido-store';
import { Observer } from 'mobx-react';
import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import type { IMfaSetupProps } from '.';

export function Passkey({ onSetupComplete, onError }: IMfaSetupProps) {
  const fidoStore = useRef(new FidoStore());
  const fidoRegister = useCallback(async () => {
    const res = await fidoStore.current.onFidoRegister();
    if (res) {
      onSetupComplete();
    } else if (onError) onError();
  }, []);
  fidoRegister();
  return (
    <Observer>
      {() => (
        <>
          <p>Please follow the instructions on your device to setup your Passkey.</p>
          {AuthStore.user.isAuthenticated && (
            <p>You will be logged in automatically when setup is successful.</p>
          )}
          {fidoStore.current.message && (
            <>
              <details className="my-2 rounded-md border border-rose-300 bg-rose-100 p-3 text-center text-sm text-rose-600">
                <summary>
                  <span>There was an error registering your account by Passkey</span>
                </summary>
                <p className="mt-2">{fidoStore.current.message}</p>
                <p className="mt-2">{fidoStore.current.error?.toString()}</p>
              </details>
              <p>
                <Link to="/login">Return to Sign in Screen</Link>
              </p>
            </>
          )}
        </>
      )}
    </Observer>
  );
}
